import { transformStringToNumberOrUndefined } from "../../../utils/stringUtils";
import yup from "../../../utils/yup";

export const schema = yup.object().shape({
  pressure: yup.string(),
  temperature: yup.string(),
  weight: yup.number().transform(transformStringToNumberOrUndefined).positive(),
  height: yup.number().transform(transformStringToNumberOrUndefined).positive(),
});
